import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../helper/proccessErrorMessage";
import { API_USER_BANK_DETAILS, API_REMOVE_BANK } from "../../../config/api";
import { showErrorModal } from "../../reducers/messageSlice";
import { getUserBanks } from "./getUserBanks";
import mixpanel from "mixpanel-browser";

export const addBankDetails = createAsyncThunk(
  "banks/add",
  async ({ data, cb, failed }, { dispatch, getState }) => {
    const { profile, user } = getState().onboarding;
    const { userBanks } = getState().bank;
    try {
      const response = await Client({
        method: "POST",
        path: API_USER_BANK_DETAILS,
        data: data,
      });

      dispatch(getUserBanks());
      cb();
      // toast.success("Bank account was successfully added.");
      mixpanel.track("WEB-Linked NGR Bank Account", {
        type: "Banks",
        // subtype: "Link Bank Account",
      });
      if (user?.hasSetPin && profile?.nok_email && userBanks?.length < 1) {
        mixpanel.track("WEB-Onboarded", {
          type: "Onboarding",
        });
      }
      return response;
    } catch (error) {
      failed();
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      mixpanel.track("WEB-Link Bank Account Failed", {
        type: "Banks",
        // subtype: "Link Bank Account",
        message: msg,
      });
      dispatch(showErrorModal(msg));
    }
  }
);
